{
  const initIFrameWatcher = () => {
    document.addEventListener("DOMContentLoaded", () => {
      const iframes = document.querySelectorAll("iframe");

      if (!iframes.length) return;

      const observer = new MutationObserver(() => {
        const activeLang = document.documentElement.lang; // Get the active language from <html lang="">

        if (activeLang) {
          iframes.forEach((iframe) => {
            const currentSrc = iframe.getAttribute("src");
            let newSrc = iframe.getAttribute(`data-gt-src-${activeLang}`);
            if (!newSrc) {
              newSrc = iframe.getAttribute("data-gt-src-original");
            }

            if (currentSrc === newSrc) return;
            if (newSrc) {
              iframe.src = newSrc;
            }
          });
        }
      });

      // Observe changes to the <html lang=""> attribute
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["lang"],
      });
    });
  }
  /**
   * get all data-components in html and initiate classes based on them
   */
  const initComponents = () => {
    const instances = _collow.instances || {}
    document
      .querySelectorAll("[data-component]")
      .forEach((root) => {
        try {
          const componentName = root.dataset.component
          if (!componentName) return;
          if (!instances[componentName]) {
            instances[componentName] = [];
          }
          const componentInstance = _collow.components[componentName].fromElement(root);      
          instances[componentName].push(componentInstance);
        } catch (error) {
          console.error(error, root);
        }
      });
      _collow.instances = instances;
  }
  // Instantiate new components now:
initComponents();
initIFrameWatcher()

  // Instantiate new components when they are added to the document:
  new MutationObserver(
    (mutations) =>
      mutations.some((mutation) => mutation.addedNodes) && initComponents()
  ).observe(document.body, { childList: true, subtree: true });


}
